import * as React from "react";
import Default from "../components/view-supplier/default-view";
import ViewA from "../components/view-supplier/A/view";
import ViewB from "../components/view-supplier/B/view";
import ViewC from "../components/view-supplier/C/view";
export default class ViewSupplier extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        let typeCase = this.props.supplier.Theme;
        if (typeCase) {
            typeCase = typeCase.toLowerCase();
        }
        switch (typeCase) {
            case "theme 1":
                return React.createElement(ViewA, Object.assign({}, this.props));
            case "theme 2":
                return React.createElement(ViewB, Object.assign({}, this.props));
            case "theme 3":
                return React.createElement(ViewC, Object.assign({}, this.props));
            default:
                return React.createElement(Default, Object.assign({}, this.props));
        }
    }
}
;
//# sourceMappingURL=view-supplier.js.map